<template>
  <div>
    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(formSubmit)">
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              type="text"
              :label="$t('Course title')"
              :name="$t('Course title')"
              v-model="model.title"
              rules="required"
              labelClasses="required form-control-label"
              maxlength="250"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-4">
            <base-input
              rules="required"
              labelClasses="required form-control-label"
              :name="$t('Category')"
              :label="$t('Category')">
              <el-select
                v-model="model.category"
                class="select-primary"
                :placeholder="$t('Choose category')">
                <el-option v-for="option in categories"
                           class="select-primary"
                           :key="option.id"
                           :value="option.id"
                           :label="option.title">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              type="text"
              :label="$t('Course url name')"
              :name="$t('Course url name')"
              v-model="model.name"
              placeholder="a-z, 0-9, _, -"
              :rules="{ required: true, regex: /^[a-z_0-9-]+$/, max: 32 }"
              labelClasses="required form-control-label">
              <template v-slot:infoBlock>
                <small>{{ $t('courseUrl.infoBlock') }}</small>
              </template>
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              :label="$t('Description')"
              :name="$t('Description')"
            >
              <textarea
                v-model="model.description"
                class="form-control"
                rows="3"></textarea>
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-8">
            <base-input
              type="text"
              :name="$t('Background gradient')"
              :label="$t('Background gradient')"
              v-model="model.properties.gradient">
              <template v-slot:infoBlock>
                <small v-html="$t('gradient.infoBlock')"></small>
              </template>
            </base-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-8">
            <transition>
              <card type="frame" class="text-white"
                    v-bind:style="{'background-image': model.properties.gradient || 'inherit'}">
                <h3 class="text-white">{{ model.title }}</h3>
                <blockquote>{{ model.description }}</blockquote>
              </card>
            </transition>
          </div>
        </div>
        <base-button
          type="primary"
          :loading="status === 1"
          native-type="submit">
          {{ $t('Create course') }}
        </base-button>
      </form>
    </validation-observer>

  </div>
</template>


<script>
  import {Select, Option} from 'element-ui';
  import {createNamespacedHelpers} from 'vuex';
  import {FormNotification, FormSubmitHandlers} from "../../../mixins/FormApiHandlers";
  import {CourseForm} from "../../../mixins/Course/CourseForm";

  const {mapState, mapActions} = createNamespacedHelpers('course');

  export default {
    name: "FormCreateCourse",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        successMessage: this.$i18n.t('You are created new course!'),
        errorMessage: this.$i18n.t('Error on creating new course!'),
        submitRedirectTo: {name: 'courses'}
      }
    },
    async created() {
      await this.loadCategories();
    },
    mixins: [FormNotification, FormSubmitHandlers, CourseForm],
    computed: {
      ...mapState({
        categories: state => state.categories,
        status: state => state.createStatus.status
      })
    },
    methods: {
      ...mapActions({
        createCourse: 'createCourse',
        loadCategories: 'loadCategories',
        revertStatus: 'revertCreateStatus'
      }),
      async formSubmit() {
        await this.createCourse({form: this.model});
      }
    }
  }
</script>
